import { Controller } from '@hotwired/stimulus'

import '../src/init/datatables'
import { handleClickableRowClick } from '../src/mixins/with_clickable_rows'

/**
 * Decorates a table with DataTables.
 *
 * Provide clickable rows by adding the visit action to each table row:
 *
 * `<tr data-action="click->local-datatable#visit">`
 */
export default class extends Controller {
  // datatable is a separate target as the element is replaced on init
  static targets = ['datatable']
  static values = {
    paging: { type: Boolean, default: true },
    saveState: { type: Boolean, default: true },
    searching: { type: Boolean, default: true }
  }

  connect () {
    this.datatable = $(this.datatableTarget).DataTable({
      ordering: $(this.datatableTarget).is('[data-order]'),
      paging: this.pagingValue, // add pagination controls
      pageLength: 10, // add a data-page-length attribute to override
      serverSide: false, // local rendering only
      stateDuration: -1, // use session (per tab) storage
      stateSave: this.saveStateValue, // remember the current configuration
      searching: this.searchingValue // add search box
    })
  }

  disconnect () {
    this.datatable.destroy()
  }

  // Finds the most relevant link to the user, and visits it (using Turbo)
  visit (event) {
    handleClickableRowClick(event)
  }
}
